import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f337dfb8")

_pushScopeId("data-v-f337dfb8")
const _hoisted_1 = { class: "card-body pt-6 pb-0" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\" data-v-f337dfb8><div class=\"fw-bold\" data-v-f337dfb8><h4 class=\"text-gray-800 fw-bolder\" data-v-f337dfb8>Please Note!</h4><div class=\"fs-6 text-gray-600\" data-v-f337dfb8><p align=\"justify\" data-v-f337dfb8>You have pending PPS for setup. To avoid PPS not getting points please setup the position of your PPS now before using pending points.</p></div></div></div>", 1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "From User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Points"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Date Encoded"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Action")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "badge badge-light-secondary" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_DashboardTabNavigator = _resolveComponent("DashboardTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DashboardTabNavigator)
      ]),
      _createVNode("div", _hoisted_2, [
        (_ctx.isShowPackagePointsWarning)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
              ]),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode("table", _hoisted_9, [
            _hoisted_10,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: { 'package-points-row--used': _ctx.isPackagePointsUsed(item) }
                }, [
                  _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                  _createVNode("td", null, _toDisplayString(item.usid), 1),
                  _createVNode("td", null, _toDisplayString(item.fullname), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(item.bp).toFixed(2))), 1),
                  _createVNode("td", null, _toDisplayString(item.dtestp), 1),
                  (_ctx.isPackagePointsReady(item))
                    ? (_openBlock(), _createBlock("td", _hoisted_11, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1",
                          disabled: _ctx.isSending,
                          onClick: ($event: any) => (_ctx.usePackagePoints(item.recid))
                        }, " Use Points ", 8, ["disabled", "onClick"])
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_12, [
                        _createVNode("span", _hoisted_13, _toDisplayString(item.sts), 1)
                      ]))
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
})